import { request } from './request';
import type { LoginResultDto } from './types';

/** 验证码使用场景（对齐后端 VerifyCodeUseScene 枚举） */
export const VERIFY_CODE_SCENE = {
  /** 登录 */
  LOGIN: 1,
  /** 忘记密码 */
  FORGOT_PASSWORD: 2,
} as const;

/**
 * 发送短信验证码（/account/sendVerifyCode，公开接口）。
 * 后端已接入阿里云短信服务（签名：北京新科国医），返回发送结果文案。
 */
export function sendVerifyCode(mobile: string, useScene: number = VERIFY_CODE_SCENE.LOGIN): Promise<string> {
  return request('/account/sendVerifyCode', { mobile, useScene });
}

/**
 * 手机号+验证码登录（/account/mobileCodeLogin，公开接口）。
 * 用户不存在时后端自动注册，成功后返回 token/uId/userName。
 */
export function mobileCodeLogin(mobile: string, code: string): Promise<LoginResultDto> {
  return request('/account/mobileCodeLogin', { mobile, code });
}
